import React, { useRef, useEffect, useState } from 'react';

interface IPanelProps {
    panelTitle?: string | React.ReactElement;
    centerPanelTitle?: boolean;
    fitPanelToScreen?: boolean;
    customSize?: number;
    height?: string;
    width?: string;
    backgroundColor?: string;
    style?: React.CSSProperties;
}

const Panel: React.FC<IPanelProps> = (props) => {
    const panelRef = useRef(null);
    const [style, setStyle] = useState<React.CSSProperties>(undefined);

    useEffect(() => {
        const boundBox = panelRef.current.getBoundingClientRect();

        if (props.fitPanelToScreen === true) {
            let newVal: number = props?.customSize ? props?.customSize : 2;
            const top = boundBox.top / 10 + newVal;

            if (props.customSize >= 2) {
                setStyle({
                    maxHeight: `calc(100vh - ${top}vh)`,
                    overflow: 'hidden',
                    height: props.height
                });
            } else {
                setStyle({
                    maxHeight: `calc(100vh - ${top}vh)`,
                    overflow: 'hidden',
                    overflowY: 'scroll',
                    height: props.height
                });
            }
        }
    }, []);

    const headerContent = () => {
        if (!props.panelTitle) {
            return undefined;
        }

        return (
            <div
                style={{
                    borderBottom: '1px solid #ccc',
                    margin: '-.5rem -.5rem 1rem -.5rem',
                    borderRadius: '.5rem .5rem 0 0',
                    background: '#EFF4F8',
                    display: !!props?.centerPanelTitle ? 'flex' : '',
                    justifyContent: !!props?.centerPanelTitle ? 'center' : 'left',
                    width: props?.width ? props?.width : '' 
                }}
            >
                {typeof props.panelTitle === 'string' ? (
                    <h2 style={{ color: '#6393C1', padding: '.5rem 1rem', margin: '0' }}>{props.panelTitle}</h2>
                ) : (
                    props.panelTitle
                )}
            </div>
        );
    };

    return (
        <div
            ref={panelRef}
            className={`dlc-content-panel`}
            style={{
                background: props.backgroundColor,
                height: props.height,
                width: props.width,
                ...((props.height || props.width) ? { boxSizing: 'border-box', display: 'flex', flexDirection: 'column' } : {}),
                ...style,
                ...props.style
            }}
            aria-disabled={true}
        >
            {headerContent()}
            {props.children}
        </div>
    );
};

Panel.defaultProps = {
    fitPanelToScreen: false,
};

Panel.displayName = 'Panel';
export default Panel;



// WEBPACK FOOTER //
// ./src/components/common/Panel.tsx